export default {
	"order.SigningFailedPleaseSignAgain": "Signing failed, please sign again",
	"order.TheDeductionWasUnsuccessfulAndTheOrderListIsBeingRedirected": "The deduction was unsuccessful, and the order list is being redirected",
	"order.PleaseConfirmThatYouHaveReadAndAgree": "Please confirm that you have read and agree",
	"order.UserServicesAgreement": "\"User Services Agreement\"",
	"order.return": "return",
	"order.agreeAndContinue": "agree and continue",
	"order.MallCashierPagepaymentMethod": "Mall cashier page_payment method",
	"order.WeChat": "WeChat",
	"order.Alipay": "Alipay",
	"order.MallCashierPageorderButton": "Mall cashier page_order button",
	"order.SorryPricesHaveChanged": "Sorry, prices have changed!",
	"order.SystemErrorPleaseTryAgainLater": "System error, please try again later",
	"order.AlipaySignedAContract": "Alipay signed a contract",
	"order.recommend": "recommend",
	"order.MallCashierPagePaymentConfirmationPopup": "Mall cashier page_Payment confirmation popup",
	"order.AfterPayingYouNeedToComeBackToConfirmThePaymentResultToEnsureTheSmoothDistributionOfThePurchasedContent": "After paying, you need to come back to confirm the payment result to ensure the smooth distribution of the purchased content!",
	"order.PaymentAmount": "Payment amount",
	"order.readAndAgree": "read and agree",
	"order.AlipayScanCodeSigningContract": "Alipay scan code signing contract",
	"order.GoToAlipayToSignAContract": "Go to Alipay to sign a contract",
	"order.cancelPayment": "cancel payment",
	"order.waitForPayment": "wait for payment…",
	"order.MallCashierPagepaymentConfirmationPopupconfirmationButton": "Mall cashier page_payment confirmation popup_confirmation button",
	"order.Paid": "Paid",
	"order.PaymentIsSuccessfulGoToReceive": "Payment is successful, go to receive",
	"order.unpaid": "unpaid",
	"order.PaymentFailedRePay": "Payment failed, re-pay",
	"order.MallCashierPagePaymentConfirmationPopupCloseButton": "Mall cashier page_Payment confirmation popup_Close button",
	"order.ConfirmationOfPaymentResult": "Confirmation of payment result",
	"order.RequestingPayment": "Requesting payment..."
}